import React from 'react';

import { Typography as MuiTypography } from '@material-ui/core';
import { TypographyProps as MuiTypographyProps } from '@material-ui/core/Typography';

export interface TypographyProps extends MuiTypographyProps {
  className?: string;
  variant?: 'h1' | 'h2' | 'h3' | 'body1' | 'body2' | 'caption' | 'button';
}

export const Typography = (props: TypographyProps): JSX.Element => {
  const { children, className = '', variant = 'body1' } = props;

  return (
    <MuiTypography className={className} variant={variant}>
      {children}
    </MuiTypography>
  );
};
